<template>
  <div class="system">
    <Menu ref="slideMenu" mode="horizontal" :active-name="activeName">
      <MenuItem :name="p.sn" :to="p.url" v-for="(p,index) in navItems" :key="index">
        <Icon :custom="p.icon" />
        {{p.menuName}}
      </MenuItem>
    </Menu>
    <div class="subContent">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemManager',
  data () {
    return {
      navItems:[],
      activeName:'1'
    }
  },
  created:function(){
    this.$router.push({path:'peoplemmanager'}); // 页面加载时跳转
  },
  mounted(){
    this.$nextTick(()=>{
      // this.menu = this.$route.path.slice(1)
      this.$refs.slideMenu.updateOpened()
    
      this.$refs.slideMenu.updateActiveName();
    })
    this.getItem()
  },
  methods:{
    getItem(){
      let data = [
        {icon:' iconfont icon-renyuanguanli',sn:'1',menuName:'人员管理',url:'/peoplemmanager'},
        {icon:' iconfont icon-keshiguanli',sn:'2',menuName:'科室管理',url:'/clinicmmanager'},
        {icon:' iconfont icon-ziyuan',sn:'3',menuName:'角色管理',url:'/rolemmanager'},
      ];
      this.navItems = data;
      this.activeName = this.navItems[0].sn;
      // this.$emit('showNavItems',this.navItems);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.system{
  overflow: scroll;
  height: 100%;
}
.subContent{
  height: 100%;
}
a{
  text-decoration:none;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item{
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/SystemManager.vue